import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/beer-bottle-amber.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/food-jar.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/liquor-bottles.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/pharma-products.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/sheet-glass.jpg");
